export const diagnosisResultStyles = `

  :root {
    --brand: #27A8BC; --brandDark: #1E8DA0; --brandSoft: #E8F6F9; --brandSoft2: #D5EDF2;
    --pageTop: #DCF1F6; --pageBottom: #F4FBFC;
    --ink: #1F2D3D; --body: #41566B; --sub: #8A9BB0;
    --cardBorder: #E4EEF2;
    --green: #2FB37A; --greenDark: #259364;
    --orange: #E9A23B; --orangeDark: #D68B25;
    --pink: #E86A9B; --pinkDark: #C95583;
    --blue: #3E8FD0; --blueDark: #2C76B7;

    /* 微グラデーション定義（135度・同系色） */
    --gradBrand:   linear-gradient(135deg, #27A8BC 0%, #1E8DA0 100%);
    --gradGreen:   linear-gradient(135deg, #34BD83 0%, #259364 100%);
    --gradOrange:  linear-gradient(135deg, #F0AC48 0%, #D68B25 100%);
    --gradPink:    linear-gradient(135deg, #ED7BA8 0%, #C95583 100%);
    --gradBlue:    linear-gradient(135deg, #4FA0DD 0%, #2C76B7 100%);
    --gradStar:    linear-gradient(135deg, #F8A14A 0%, #E27319 100%);

    /* 背景用微グラデ */
    --gradBrandSoft:  linear-gradient(135deg, #EEF8FB 0%, #DCEEF3 100%);
    --gradOrangeSoft: linear-gradient(135deg, #FDF6E6 0%, #F8E7C0 100%);
    --gradPanel:      linear-gradient(160deg, #FFFFFF 0%, #FAFDFE 100%);
    --gradCTA:        linear-gradient(135deg, #2DB6CB 0%, #1B7E91 100%);
  }
  .dr-root {
    min-height: 100vh;
    background: linear-gradient(180deg, var(--pageTop), var(--pageBottom));
    display: flex; justify-content: center;
    font-family: "Hiragino Sans","Noto Sans JP","Yu Gothic UI",system-ui,sans-serif;
    color: var(--body);
  }
  .dr-container { width: 100%; max-width: 440px; padding: 12px 0 28px; overflow-x: clip; }
  .dr-panel {
    background: var(--gradPanel);
    margin: 8px 12px 0; border-radius: 22px;
    padding: 20px; box-shadow: 0 8px 30px rgba(31,45,61,0.06);
    display: flex; flex-direction: column; gap: 14px;
  }
  .dr-hero { display: flex; gap: 12px; align-items: flex-start; }
  .dr-hero-info { flex: 1; min-width: 0; }
  .dr-title {
    margin: 4px 0 12px; font-size: clamp(22px, 6.4vw, 26px); font-weight: 900;
    line-height: 1.15;
    background: var(--gradBrand);
    -webkit-background-clip: text; background-clip: text;
    -webkit-text-fill-color: transparent; color: transparent;
  }
  .dr-title-sub {
    font-size: 16px;
    -webkit-text-fill-color: var(--ink); color: var(--ink);
    background: none;
  }
  .dr-char-wrap { width: 132px; flex-shrink: 0; display: grid; place-items: center; background: transparent; overflow: visible; }
  .dr-char-stage {
    position: relative; width: 100%; aspect-ratio: 1;
    display: grid; place-items: center;
  }
  .dr-char-blob {
    position: absolute; z-index: 0;
    left: -10%; right: -10%; top: 10%; bottom: -2%;
    background:
      radial-gradient(ellipse 88% 74% at 54% 56%, rgba(var(--brandRgb), 0.36) 0%, rgba(var(--brandRgb), 0.22) 48%, rgba(var(--brandRgb), 0.08) 72%, transparent 100%),
      radial-gradient(ellipse 62% 50% at 34% 48%, rgba(var(--brandRgb), 0.2) 0%, transparent 72%);
    border-radius: 56% 44% 52% 48% / 50% 46% 54% 50%;
    pointer-events: none;
  }
  .dr-char-blob-pattern { position: absolute; inset: 0; }
  .dr-char-blob-icon {
    position: absolute; display: grid; place-items: center;
    color: rgba(var(--brandRgb), 0.6); opacity: 0.34;
  }
  .dr-char-sparkle {
    position: absolute; z-index: 2; pointer-events: none;
  }
  .dr-char-img {
    position: relative; z-index: 1;
    width: 100%; max-width: 100%; object-fit: contain;
    background: transparent;
  }
  .dr-char-fallback { position: relative; z-index: 1; }
  .dr-two-col { display: grid; grid-template-columns: 1fr; gap: 12px; }
  .dr-card {
    background: var(--gradPanel);
    border: 1px solid var(--cardBorder);
    border-radius: 18px; box-shadow: 0 1px 2px rgba(31,45,61,0.04); overflow: hidden;
  }
  .dr-card-head { display: flex; align-items: center; gap: 8px; padding: 14px 16px 8px; }
  .dr-card-head h3 {
    margin: 0; font-size: 15px; font-weight: 800;
    -webkit-background-clip: text; background-clip: text;
    -webkit-text-fill-color: transparent; color: transparent;
  }
  .dr-card-head h3 .badge {
    background: none;
    -webkit-text-fill-color: var(--sub); color: var(--sub);
    font-weight: 700; font-size: 13px;
  }
  .dr-card-body { padding: 0 16px 16px; }
  .dr-section-grid { display: flex; flex-direction: column; gap: 14px; }
  .dr-orange-card {
    background: var(--gradOrangeSoft);
    border: 1px solid #F4E2C2; border-radius: 18px; padding: 14px 16px;
  }
  .dr-style-box {
    background: var(--gradBrandSoft);
    border-radius: 12px; padding: 10px 12px;
    font-size: 12.5px; line-height: 1.7; color: var(--body);
  }
  .dr-axis-row { display: flex; align-items: flex-start; flex-wrap: wrap; gap: 6px 8px; margin-bottom: 8px; }
  .dr-axis-row > span:last-child { flex: 1 1 120px; min-width: 0; line-height: 1.45; }
  .dr-axis-pill {
    background: var(--gradBrand);
    color: #fff; font-weight: 800;
    font-size: 12px; padding: 4px 10px; border-radius: 8px;
    min-width: 56px; text-align: center; flex-shrink: 0;
    box-shadow: 0 1px 3px rgba(var(--brandRgb), 0.3);
    letter-spacing: 0.3px;
  }
  .dr-info-row {
    display: flex; align-items: flex-start; flex-wrap: wrap; gap: 6px 8px;
    background: var(--gradBrandSoft);
    border-radius: 10px; padding: 8px 10px; margin-bottom: 8px;
  }
  .dr-info-row > svg { flex-shrink: 0; margin-top: 2px; }
  .dr-info-row > span:not(.dr-info-label) { flex: 1 1 160px; min-width: 0; line-height: 1.5; word-break: break-word; }
  .dr-info-label { font-size: 13px; font-weight: 700; color: var(--ink); flex-shrink: 0; white-space: nowrap; }
  .dr-stars svg { width: 17px; height: 17px; }
  .dr-aaru-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px 12px;
  }
  .dr-aaru-grid--odd .dr-aaru-item:last-child {
    grid-column: 1 / -1;
  }
  .dr-aaru-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    min-width: 0;
    padding: 9px 10px;
    background: var(--gradBrandSoft);
    border-radius: 12px;
    border: 1px solid rgba(var(--brandRgb), 0.1);
  }
  .dr-aaru-icon {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: rgba(var(--brandRgb), 0.14);
    display: grid;
    place-items: center;
    margin-top: 1px;
  }
  .dr-aaru-text {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.5;
    color: var(--ink);
    word-break: break-word;
  }
  .dr-manual-row { display: flex; align-items: flex-start; gap: 8px; margin-bottom: 8px; font-size: 13.5px; line-height: 1.5; }
  .dr-bullet-list { list-style: none; margin: 0; padding: 0; }
  .dr-bullet-item { display: flex; gap: 8px; margin-bottom: 8px; line-height: 1.55; font-size: 13.5px; }
  .dr-stars { display: inline-flex; align-items: center; gap: 2px; }
  .dr-cta-banner {
    margin: 16px 12px 0;
    width: calc(100% - 24px);
    box-sizing: border-box;
    padding: 28px 20px 24px;
    border-radius: 24px;
    text-align: center;
    color: #fff;
    background: var(--gradCTABanner);
    box-shadow: 0 10px 28px rgba(var(--brandRgb), 0.22);
  }
  .dr-cta-title {
    margin: 0 0 10px;
    font-size: 22px;
    font-weight: 800;
    line-height: 1.35;
    letter-spacing: 0.02em;
  }
  .dr-cta-desc {
    margin: 0 0 20px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.55;
    opacity: 0.92;
  }
  .dr-cta-actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .dr-cta-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 48px;
    padding: 12px 22px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.3;
    text-decoration: none;
    cursor: pointer;
    border: none;
    transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
    white-space: nowrap;
  }
  .dr-cta-btn:hover { transform: translateY(-1px); }
  .dr-cta-btn--primary {
    background: var(--gradCTA);
    color: #fff;
    box-shadow: 0 6px 18px rgba(var(--brandRgb), 0.35);
  }
  .dr-cta-btn--primary:hover {
    box-shadow: 0 8px 22px rgba(var(--brandRgb), 0.42);
  }
  .dr-cta-btn--ghost {
    background: transparent;
    color: #fff;
    border: 1.5px solid rgba(255, 255, 255, 0.92);
    box-shadow: none;
  }
  .dr-cta-btn--ghost:hover {
    background: rgba(255, 255, 255, 0.12);
  }
  .dr-cta-btn i { font-size: 18px; line-height: 1; }

  /* === Mobile layout (〜767px) === */
  @media (max-width: 767px) {
    .dr-container { padding-top: 8px; }
    .dr-panel { margin: 6px 8px 0; padding: 16px 14px; gap: 12px; border-radius: 18px; }
    .dr-hero {
      flex-direction: column;
      align-items: stretch;
      gap: 2px;
    }
    .dr-hero-info { width: 100%; }
    .dr-char-wrap {
      width: min(196px, 52vw);
      margin: 2px auto 6px;
      align-self: center;
    }
    .dr-char-blob { left: -6%; right: -6%; top: 12%; bottom: 0; }
    .dr-char-blob-pattern { transform: scale(0.92); transform-origin: center; }
    .dr-title { margin-bottom: 10px; }
    .dr-title-sub { font-size: 15px; }
    .dr-aaru-grid { grid-template-columns: 1fr; gap: 8px; }
    .dr-aaru-grid--odd .dr-aaru-item:last-child { grid-column: auto; max-width: none; }
    .dr-aaru-item { padding: 8px 10px; }
    .dr-aaru-text { font-size: 12.5px; }
    .dr-card-head { padding: 12px 14px 6px; }
    .dr-card-body { padding: 0 14px 14px; }
    .dr-orange-card { padding: 12px 14px; }
    .dr-cta-banner { margin: 14px 8px 0; width: calc(100% - 16px); padding: 22px 16px 18px; border-radius: 20px; }
    .dr-cta-title { font-size: 18px; margin-bottom: 8px; }
    .dr-cta-desc { font-size: 12.5px; margin-bottom: 16px; }
    .dr-cta-btn { font-size: 13px; padding: 11px 16px; min-height: 44px; white-space: normal; }
  }

  /* === PC layout (768px+) === */
  @media (min-width: 768px) {
    .dr-container { max-width: 1080px; padding: 16px 24px 40px; }
    .dr-panel { margin: 12px 0 0; border-radius: 28px; padding: 32px 36px; gap: 20px; }
    .dr-hero { flex-direction: row; align-items: center; gap: 24px; }
    .dr-two-col { grid-template-columns: 1fr 1fr; }
    .dr-stars svg { width: 20px; height: 20px; }
    .dr-char-wrap { width: 300px; order: 2; }
    .dr-char-blob { left: -8%; right: -8%; top: 8%; bottom: 0; }
    .dr-char-blob-icon { opacity: 0.3; }
    .dr-char-img { width: 112%; }
    .dr-hero-info { order: 1; flex: 1; }
    .dr-title { font-size: 44px; margin-bottom: 16px; }
    .dr-title-sub { font-size: 26px; }
    .dr-section-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; align-items: start; }
    .dr-card-head h3 { font-size: 17px; }
    .dr-bullet-item { font-size: 14.5px; }
    .dr-manual-row { font-size: 14.5px; }
    .dr-style-box { font-size: 14px; }
    .dr-aaru-text { font-size: 13.5px; }
    .dr-cta-banner { margin: 24px 0 0; width: 100%; padding: 36px 32px 32px; border-radius: 28px; }
    .dr-cta-title { font-size: 28px; margin-bottom: 12px; }
    .dr-cta-desc { font-size: 16px; margin-bottom: 24px; }
    .dr-cta-actions { flex-direction: row; justify-content: center; align-items: center; gap: 14px; }
    .dr-cta-btn { font-size: 15px; padding: 13px 28px; min-height: 50px; }
  }

`;
